import {createAction} from 'util/redux'
import {MemoActionExtPayload, MemoActionPayload} from 'module/Memo/type/MemoActionPayload'

const NAMESPACE = 'Memo/'

export const memoAddAction = createAction<MemoActionExtPayload>(NAMESPACE + 'Add')
export const memoToggleAction = createAction<MemoActionExtPayload>(NAMESPACE + 'Toggle')
export const memoRemoveAction = createAction<MemoActionPayload>(NAMESPACE + 'Remove')